import { useState, useEffect } from 'react'
import { motion, AnimatePresence } from 'framer-motion'
import { banners } from '../../data'

export function HomeBanner() {
  const [currentIndex, setCurrentIndex] = useState(0)

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentIndex((prev) => (prev + 1) % banners.length)
    }, 5000)
    return () => clearInterval(interval)
  }, [])

  return (
    <section className="relative h-screen overflow-hidden">
      <AnimatePresence mode="wait">
        <motion.div
          key={currentIndex}
          initial={{ opacity: 0.5, y: 0 }}
          animate={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0.5, y: 0 }}
          transition={{ duration: 1, ease: 'linear' }}
          className="absolute inset-0"
        >
          <div
            className="absolute inset-0 bg-cover bg-center"
            style={{
              backgroundImage: `url(https://trae-api-cn.mchost.guru/api/ide/v1/text_to_image?prompt=supply%20chain%20management%20system%20dashboard%20with%20food%20safety%20tracking&image_size=landscape_16_9)`,
              backgroundPosition: 'center',
              backgroundSize: 'cover'
            }}
          >
            <div className="absolute inset-0 bg-black/50"></div>
          </div>
          <div className="container-custom h-full flex items-center relative z-10">
            <div className="max-w-2xl">
              <motion.h1
                initial={{ y: 30, opacity: 0 }}
                animate={{ y: 0, opacity: 1 }}
                transition={{ duration: 0.8, delay: 0.2, ease: 'easeOut' }}
                className="text-3xl md:text-4xl lg:text-6xl font-bold text-white leading-tight mb-6"
              >
                {banners[currentIndex].title}
              </motion.h1>
              <motion.p
                initial={{ y: 30, opacity: 0 }}
                animate={{ y: 0, opacity: 1 }}
                transition={{ duration: 0.8, delay: 0.4, ease: 'easeOut' }}
                className="text-xl text-white/80 mb-8"
              >
                {banners[currentIndex].subtitle}
              </motion.p>
              {/* <motion.div
                initial={{ y: 30, opacity: 0 }}
                animate={{ y: 0, opacity: 1 }}
                transition={{ duration: 0.8, delay: 0.6, ease: 'easeOut' }}
              >
                <Button
                  variant="default"
                  size="lg"
                  className="group"
                  asChild
                >
                  <a href={banners[currentIndex].link} className="flex items-center">
                    {banners[currentIndex].ctaText}
                    <ArrowRight className="ml-2 w-5 h-5 transition-transform duration-300 group-hover:translate-x-1" />
                  </a>
                </Button>
              </motion.div> */}
            </div>
          </div>
        </motion.div>
      </AnimatePresence>

      <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 flex space-x-2 z-20">
        {banners.map((_, index) => (
          <motion.button
            key={index}
            onClick={() => setCurrentIndex(index)}
            initial={{ width: '0.75rem', opacity: 0.5 }}
            animate={{
              width: index === currentIndex ? '3rem' : '0.75rem',
              opacity: index === currentIndex ? 1 : 0.5
            }}
            transition={{ duration: 0.3, ease: 'easeOut' }}
            className="h-3 rounded-full bg-white"
          />
        ))}
      </div>
    </section>
  )
}
